import { useState } from 'react'
import { updateProcodocsRequest } from '../../../../../lib/fetchApi'
import { useDispatch, useSelector } from 'react-redux'
import InputBox from '../../../../common/interactive/InputBox'
import TextareaBox from '../../../../common/interactive/TextareaBox'
import Button from '../../../../common/Button'
import { notificationActions } from '../../../../../store/notifications'

export default function UpdateRequest({request, closeUpdateRequestHandler, refreshRequests}) {
    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const caseId = useSelector(state => state.case.activeCase.case.id)
    const [isLoading, setIsLoading] = useState(false)

    async function submitHandler(event) {
        event.preventDefault()
        setIsLoading(true)
        try {
            const fd = new FormData(event.target)
            const data = Object.fromEntries(fd.entries())
            const update = await updateProcodocsRequest(userToken, caseId, request.id, data)
            if (update?.errorMessage) {
                dispatch(notificationActions.setError(update))
            } else {
                if (refreshRequests) {
                    refreshRequests()
                }
                if (closeUpdateRequestHandler) {
                    closeUpdateRequestHandler()
                }
            
            }
        } finally {
            setIsLoading(false)
        }
    }
    return <form onSubmit={submitHandler}>
        <div className="row">
            <h3>Update Request</h3>
        </div>
        <div className="row">
            <InputBox label="Title" type="text" name="title" required={true} placeholder="" />
        </div>
        <div className="row">
            <TextareaBox label="Description" name="description" required={true} placeholder="" />
        </div>
        <div className="row">
            <Button title="Update" btnStyle="btn_small" type={'submit'} isLoading={isLoading}>Update Request</Button>
        </div>
    </form>
}